<template>
  <section>
    <div class="header">
      <div class="head rank">Rank</div>
      <div class="head company">Name</div>
      <div class="head members">Members</div>
      <div class="head average">Average Exp.</div>
      <div class="head total">Total Exp.</div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'TableHeader',
  };
</script>

<style scoped lang="sass">
  @import "../../../assets/scss/variables"
  section
    margin-top: 40px

  .header
    font-weight: bold
    font-size: 14px
    line-height: 22px
    color: var(--color-dark-gray)
    height: 92px
    margin: 0 30px
    display: grid
    border-bottom: #e6ebee 3px solid
    grid-template-columns: 1fr 4fr 2fr 2fr 2fr
    .dark &
      border-bottom-color: var(--color-dark-border)
      color: inherit

    @media screen and (min-width: 992px) and (max-width: 1249px)
      grid-template-columns: 1fr 4fr 2fr 2fr 2fr
      width: 870px

    @media screen and (min-width: 768px) and (max-width: 991px)
      grid-template-columns: 1fr 4fr 2fr 2fr 2fr
      width: 630px

    @media screen and (max-width: 767px)
      grid-template-columns: 1fr 1fr 1fr
      grid-template-rows: 1fr 1fr
      width: 100%
      margin: 0

    .head
      margin: auto auto auto 10px
      color: #6c757d
      font-weight: bold
      .dark &
        color: inherit

    .rank
      grid-column: 1
      margin: auto auto auto 0

      @media screen and (max-width: 767px)
        grid-column: 1
        grid-row: 1
        margin-left: 10px

    .company
      grid-column: 2

      @media screen and (max-width: 767px)
        grid-column: 2
        grid-row: 1

    .members
      grid-column: 3

      @media screen and (max-width: 767px)
        grid-column: 3
        grid-row: 1

    .average
      grid-column: 4

      @media screen and (max-width: 767px)
        grid-column: 1
        grid-row: 2

    .total
      grid-column: 5

      @media screen and (max-width: 767px)
        grid-column: 2
        grid-row: 2
    @media screen and (min-width: 768px)
      .members,
      .average,
      .total
        margin: auto 0 auto 10px
        text-align: right
</style>
